import { render } from "./EstoqueLote.vue?vue&type=template&id=0bc4e9e8"
import script from "./EstoqueLote.vue?vue&type=script&lang=js"
export * from "./EstoqueLote.vue?vue&type=script&lang=js"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__